<template>
  <el-cascader
    style="width: 100%"
    v-model="cascaderValue"
    :options="options"
    :props="cascaderProps"
    @change="handleChange"
    clearable
  ></el-cascader>
</template>

<script>
import { getAllTree } from "@/views/commonApi";

export default {
  name: "Custom-Cascader",
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    // options: {
    //   type: Array,
    //   default: () => [],
    // },
    // 可以自定义配置项
    props: {
      type: Object,
      default: () => ({
        value: "deptId",
        label: "deptName",
        children: "children",
      }),
    },
  },
  data() {
    return {
      cascaderValue: [],
      options: [],
    };
  },
  computed: {
    cascaderProps() {
      return {
        checkStrictly: true,
        emitPath: false,
        ...this.props,
      };
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.setCascaderValueFromId(newVal);
        } else {
          this.cascaderValue = [];
        }
      },
    },
    options: {
      immediate: true,
      handler() {
        if (this.value) {
          this.setCascaderValueFromId(this.value);
        }
      },
    },
  },
  created() {
    this.getTree();
  },
  methods: {
    getTree() {
      getAllTree().then((res) => {
        if (res.code === 200) {
          this.options = res.data;
        }
      });
    },
    // 根据ID查找级联路径
    findPathById(nodes, id, path = []) {
      if (!Array.isArray(nodes)) return null;

      for (const node of nodes) {
        if (!node) continue;

        const nodeValue = node[this.cascaderProps.value];
        const newPath = path.concat(nodeValue);

        if (nodeValue === id) {
          return newPath;
        }

        if (Array.isArray(node[this.cascaderProps.children])) {
          const found = this.findPathById(
            node[this.cascaderProps.children],
            id,
            newPath
          );
          if (found) return found;
        }
      }
      return null;
    },
    // 根据ID设置级联值
    setCascaderValueFromId(id) {
      if (!id) {
        this.cascaderValue = [];
        return;
      }

      const path = this.findPathById(this.options, id);
      this.cascaderValue = Array.isArray(path) ? path : [];
    },
    // 处理选择变化
    handleChange(value) {
      // const selectedId = value.length > 0 ? value[value.length - 1] : "";
      this.$emit("input", value);
      // this.$emit("change", {
      //   id: selectedId,
      //   path: value,
      // });
    },
  },
};
</script>
